export const SERVICE_TYPE_AND_TIME_TEST_IDS = {
    root: 'scheduling-modal',
    submit: 'submit',
    cancel: 'cancel',
    orderTypeDropDownBtn: 'order-type'
};

export const SERVICE_TYPE_AND_TIME_MODAL_ID = 'service-type-and-time-id';
